import { Css, Palette, useTestIds } from "@homebound/beam";
import { Icon } from "src/components";
import { count } from "src/utils";

type MissingCostsCardProps = { missingLines: number };

export function MissingCostsCard({ missingLines }: MissingCostsCardProps) {
  const tid = useTestIds({});
  if (missingLines === 0) return null;
  return (
    <div {...tid.missingCostsCard} css={Css.bgWhite.ba.bcOrange700.bw2.br12.p2.df.gap1.mb2.$}>
      <div>
        <Icon icon="finances" color={Palette.Orange700} />
      </div>
      <div css={Css.df.fdc.$}>
        <span css={Css.mdSb.pb1.$}>{count(missingLines, "Missing Cost")}</span>
        <span css={Css.sm.gray700.$}>Bid lines missing costs are highlighted below.</span>
      </div>
    </div>
  );
}
